import { NavLink, Outlet } from 'react-router-dom';
import { BarChart3, History, LayoutDashboard, LogOut, Settings, Upload, User, Users } from 'lucide-react';
import DateRangeFilter from './DateRangeFilter';
import PdfExportButton from './PdfExportButton';
import { useAuth } from '../contexts/AuthContext';
import { useActiveUpload } from '../contexts/ActiveUploadContext';
import { safeDateLabel } from '../utils/formatters';

const navItems = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/team-performance', label: 'Team Member Performance', icon: Users },
  { to: '/team-member-detail', label: 'Individual Performance', icon: User },
  { to: '/state-client-summary', label: 'State & Client Summary', icon: BarChart3 },
  { to: '/upload', label: 'Upload Report', icon: Upload, adminOnly: true },
  { to: '/history', label: 'Upload History', icon: History },
  { to: '/settings', label: 'Settings / Column Mapping', icon: Settings, adminOnly: true },
];

export default function Layout() {
  const { signOut, profile, isAdmin } = useAuth();
  const { activeUpload } = useActiveUpload();

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand">
          <div className="brand-mark">KPI</div>
          <div>
            <strong>Operations</strong>
            <span>Dashboard</span>
          </div>
        </div>
        <nav className="nav-list">
          {navItems.filter((item) => !item.adminOnly || isAdmin).map((item) => {
            const Icon = item.icon;
            return (
              <NavLink key={item.to} to={item.to} className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                <Icon size={18} />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>
        <div className="sidebar-footer">
          <div className="profile-pill">
            <strong>{profile?.full_name || profile?.email || 'User'}</strong>
            <span>{profile?.role || 'viewer'}</span>
          </div>
          <button type="button" className="button ghost full" onClick={signOut}>
            <LogOut size={16} /> Sign out
          </button>
        </div>
      </aside>

      <main className="main">
        <header className="top-header">
          <div>
            <h1>Operations KPI Dashboard</h1>
            <p>
              Active upload: <strong>{activeUpload?.file_name || 'None'}</strong>
              {activeUpload?.uploaded_at ? ` • ${safeDateLabel(activeUpload.uploaded_at)}` : ''}
            </p>
          </div>
          <div className="top-controls">
            <DateRangeFilter />
            <PdfExportButton />
          </div>
        </header>
        <section className="page-content">
          <Outlet />
        </section>
      </main>
    </div>
  );
}
